module.exports = __webpack_public_path__ + "static/media/logo.fb124eb7.svg";